<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'

import Resizable from '@src/mixins/resizable.js'
import Card from '@components/prague-attraction-card.vue'
import 'swiper/css/swiper.css'

export default {
  props: {
    attractions: {
      type: Array,
      // required: true
    },
    id: {
      type: String,
      default: 'attractions-slider'
    },
    isntPaginated: {
      type: Boolean,
    }
  },
  mixins: [
    Resizable
  ],
  components: {
    Swiper,
    SwiperSlide,
    Card,
  },
  directives: {
    swiper: directive
  },
  data() {
    return {
      swiperOptions: {
        allowTouchMove: true,
        spaceBetween: 20,
        navigation: {
          nextEl: `.right-control.${this.id}`,
          prevEl: `.left-control.${this.id}`
        },
        pagination: {
          el: '.pagination',
          clickable: true,
          bulletClass: 'bullet',
          bulletActiveClass: 'bullet-active'
        },
        breakpoints: {
          320: {
            slidesPerView: 1.1,
            slidesPerGroup: 1.1,
          },
          768: {
            speed: 1300,
            slidesPerView: 4,
            slidesPerGroup: 3,
          }
        }
      }
    }
  }
}
</script>

<template>
  <div class="carousel-container justify-center">
    <div v-if="attractions.length > 4" class="left-control" :class="id"></div>
    <div class="container">
      <Swiper :id="id" ref="attractionsSwiper" :options="swiperOptions">
        <SwiperSlide v-for="attraction in attractions" :key="attraction._id">
          <Card :attraction="attraction"/>
        </SwiperSlide>
        <div v-if="!desktopScreen" slot="pagination" class="pagination" :class="!isntPaginated ? '' : 'disabled'"></div>
      </Swiper>
    </div>
    <div v-if="attractions.length > 4" class="right-control" :class="id"></div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
::v-deep .swiper-wrapper,
.swiper-container {
  // we need the slider not to overlap the toggled dropdown menu
  z-index: auto;
}


.break {
  width: 100%;
}

.carousel-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-flow: row wrap;
  align-items: center;
}

.control-mixin {
  height: 24px;
  width: 14.83px;
  cursor: pointer;
}

.pagination {
  margin-top: 15px;

  &.disabled {
    display: none;
  }
}

.right-control,
.left-control {
  &.swiper-button-disabled {
    opacity: 0.2;
    cursor: default;
  }
}

@media only screen and (max-width: $screen-width-xs) {
  .right-control,
  .left-control {
    display: none;
  }
}

.left-control {
  @extend .control-mixin;
  margin-right: 20px;
  background: url("../../../assets/icons/left-arrow.svg");
}

.right-control {
  @extend .control-mixin;
  margin-left: 20px;
  background: url("../../../assets/icons/right-arrow.svg");
}
</style>
